import { Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';

import { createBaseTaskColumns } from './columns/standardColumns';
import { VERTICAL_COLUMN_FACTORIES } from './columns/verticalColumns';
import { getVerticalConfig } from './config/taskVerticals';
import { TaskVerticalView } from './TaskVerticalView';

const Loading = () => (
  <div className="flex h-full items-center justify-center py-12">
    <div className="h-8 w-8 animate-spin rounded-full border-4 border-zinc-200 border-t-blue-600 dark:border-zinc-700 dark:border-t-blue-400" />
  </div>
);

/**
 * TasksVerticalRouter - Routes to the appropriate task vertical view
 *
 * Routes (all under /tasks):
 * - /tasks (no param) -> All Tasks (default)
 * - /tasks?vertical=claims -> Claims DataTable view
 * - /tasks?vertical=liability -> Liability (Police Reports) DataTable view
 * - /tasks?vertical=medical -> Medical DataTable view
 * - /tasks?vertical=demand -> Demand DataTable view
 * - /tasks?vertical=intake -> Initial Review DataTable view
 * - /tasks?vertical=intakes -> Intake DataTable view
 * - /tasks?vertical=miscellaneous -> Miscellaneous DataTable view
 *
 * The vertical param determines which predefined workspace/view to show.
 * Each vertical can define its own base filters and column configuration.
 */
export const TasksVerticalRouter = () => {
  const [searchParams] = useSearchParams();
  // Default to 'all' when no vertical param is present
  const verticalId = searchParams.get('vertical') || 'all';
  const verticalConfig = getVerticalConfig(verticalId);

  // Get the appropriate column factory for this vertical
  const factory =
    VERTICAL_COLUMN_FACTORIES[verticalConfig.id] ||
    ((options) => createBaseTaskColumns(options));

  return (
    <Suspense fallback={<Loading />}>
      <TaskVerticalView
        verticalConfig={verticalConfig}
        columnsFactory={factory}
      />
    </Suspense>
  );
};
